import { DomainAdd, Refresh, ViewColumn } from '@mui/icons-material'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from '@mui/material'
import { GridToolbarContainer, useGridApiContext } from '@mui/x-data-grid-pro'
import { useState } from 'react'
import { ToolbarInput } from '../../../../utils/ToolbarInput'
import AddNewCenterModal from '../Modals/AddNewCenterModal'

export type ToolbarProps = {
  title: string
  onRefresh: () => void
  searchText: string
  setSearchText: React.Dispatch<React.SetStateAction<string>>
  canCreateCenter: boolean
}

export function Toolbar({
  canCreateCenter,
  title,
  onRefresh,
  searchText,
  setSearchText,
}: ToolbarProps) {
  const apiRef = useGridApiContext()

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const [openCenterDialog, setOpenCenterDialog] = useState(false)

  const openModal = () => {
    setOpenCenterDialog(true)
  }

  const open = Boolean(anchorEl)
  const columns = apiRef.current.getAllColumns()
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleHide = (event: React.MouseEvent<any>) => {
    const column = columns.find(
      (column) => column.field === event.currentTarget.id,
    )
    if (column) apiRef.current.setColumnVisibility(column.field, !!column.hide)
  }

  return (
    <GridToolbarContainer
      sx={{
        background: 'linear-gradient(60deg, #84c2ce, #96dcea)',
        borderRadius: '0px 15px 0px 0px',
      }}
    >
      {openCenterDialog && (
        <AddNewCenterModal
          open={openCenterDialog}
          setOpen={setOpenCenterDialog}
        />
      )}

      <Box
        ml={2}
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        sx={{ pr: 10 }}
      >
        <LocalHospitalIcon
          sx={{
            marginRight: '1rem',
            padding: '0px 10px 0px 0px',
            color: 'white',
            width: '10% ',
            height: '10%',
          }}
        />

        <Typography
          variant="h5"
          color="primary"
          sx={{ fontWeight: 'bold', color: 'white' }}
        >
          {title}
        </Typography>
      </Box>

      <Box sx={{ flexGrow: 1 }} />
      {/* <GridToolbarDensitySelector /> */}
      {/* <GridToolbarExport /> */}
      {/* <GridToolbarFilterButton /> */}

      {!!canCreateCenter && (
        <Tooltip title={'Inscrire un centre'} style={{ marginRight: '5px' }}>
          <IconButton onClick={openModal}>
            <DomainAdd />
          </IconButton>
        </Tooltip>
      )}

      <ToolbarInput searchText={searchText} setSearchText={setSearchText} />
      <Tooltip title={'Colonnes'}>
        <IconButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <ViewColumn />
        </IconButton>
      </Tooltip>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {columns.map((column, key) => (
          <MenuItem key={key} onClick={handleHide} id={column.field}>
            <FormControlLabel
              control={<Checkbox checked={!column.hide} />}
              label={column.headerName as string}
            />
          </MenuItem>
        ))}
      </Menu>

      <Tooltip title={'Rafraîchir'}>
        <IconButton onClick={onRefresh}>
          <Refresh />
        </IconButton>
      </Tooltip>
    </GridToolbarContainer>
  )
}
